import React from 'react';

const ConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  icon = 'info',
  disableConfirm = false,
  hideCancel = false,
}) => {
  if (!isOpen) return null;

  const getIcon = () => {
    switch (icon) {
      case 'warning':
        return (
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
          />
        );
      case 'info':
      default:
        return (
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        );
    }
  };

  return (
    <div className="bg-black fixed inset-0 z-50 flex items-center justify-center bg-opacity-50">
      <div className="mx-4 w-full max-w-md rounded-lg bg-white p-4 shadow-lg dark:bg-navy-700 md:mx-0 md:p-8">
        <div className="flex items-start">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-12 w-12 rounded-full border border-blue-100 bg-blue-50 p-2 text-blue-400 md:h-16 md:w-16 md:p-3"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            {getIcon()}
          </svg>
          <div className="ml-3 flex-1 md:ml-4">
            <h2 className="text-base font-medium dark:text-white md:text-lg">
              {title}
            </h2>
            <p className="mt-2 text-sm text-gray-600">{message}</p>
          </div>
        </div>
        <div className="mt-6 flex justify-end space-x-3">
          <button
            onClick={onConfirm}
            disabled={disableConfirm}
            className={`rounded-full border-2 border-blue-500 px-4 py-2 text-sm font-medium text-white shadow-sm transition duration-200 ${
              disableConfirm
                ? 'cursor-not-allowed bg-blue-300 opacity-70'
                : 'bg-blue-500 hover:bg-blue-600 hover:shadow-lg'
            }`}
          >
            {disableConfirm ? 'Processing...' : confirmText}
          </button>
          {!hideCancel && (
            <button
              onClick={onClose}
              disabled={disableConfirm}
              className={`rounded-full border-2 border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 shadow-sm transition duration-200 ${
                disableConfirm
                  ? 'cursor-not-allowed opacity-70'
                  : 'hover:bg-gray-100 hover:shadow-lg'
              }`}
            >
              {cancelText}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
